//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Confirmation',
  data() {
    return {
      open: false,
      component: null,
      props: {},
      message: null,
      messageSize: null,
      confirmText: null,
      confirmType: null,
      showCancel: true,
      cancelText: null,
      cancelType: null,
      beforeConfirm: null,
    };
  },
  created() {
    this.$container.eventBus.on('toggleConfirmation', (e) => {
      if (e.promise && e.promise.resolve) {
        this.message = e.message || 'Are you sure?';
        this.component = e.component;
        this.props = e.props || {};
        this.messageSize = e.messageSize || 'in-your-face';
        this.confirmText = e.confirmText || 'Confirm';
        this.confirmType = e.confirmType || 'danger';
        if (e.showCancel === false) {
          this.showCancel = false;
        }
        this.cancelText = e.cancelText || 'Cancel';
        this.cancelType = e.cancelType || 'primary';
        this.confirmationPromise = e.promise;
        this.beforeConfirm = e.beforeConfirm;
        this.open = true;
      } else {
        this.open = false;
      }
    });
  },
  methods: {
    close() {
      this.open = false;
    },
    async confirm() {
      if (this.beforeConfirm && !await this.beforeConfirm()) {
        return;
      }
      this.confirmationPromise.resolve(true);
      this.close();
    },
    cancel() {
      this.confirmationPromise.resolve(false);
      this.close();
    },
  },
};
